var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEkisLogoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 79.178,
    viewBox: "0 0 250 79.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOGO_EKIS_OK",
    "data-name": "LOGO EKIS OK",
    transform: "translate(125 39.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-125 -39.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 3.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M31.656,77.973l-16.424,18.3a4.589,4.589,0,0,1-7.166-.421L.838,85.6a4.59,4.59,0,0,1,.15-5.488L9.139,69.786a4.588,4.588,0,0,0,0-5.688L.987,53.776a4.589,4.589,0,0,1-.15-5.488L8.066,38.033a4.589,4.589,0,0,1,7.166-.421L25.306,48.837,18.98,56.608a4.589,4.589,0,0,0,0,5.794Z",
    transform: "translate(0 -22.039)",
    fill: "#00e6f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M78.7,47.658,92.446,62.448a4.558,4.558,0,0,1-.247,6.494L80.031,81.577a4.589,4.589,0,0,1-6.673-.473L58.624,63l7.149-7.965a4.589,4.589,0,0,0,0-6.13l-13.5-15.04L72.712,8.76a4.589,4.589,0,0,1,6.673-.473L92.2,20.124a4.589,4.589,0,0,1,.248,6.495L78.7,41.41A4.59,4.59,0,0,0,78.7,47.658Z",
    transform: "translate(-26.968 -7.068)",
    fill: "#893eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M57.934,83.594l-7.149,7.965L38.109,75.988a4.589,4.589,0,0,1,0-5.794l6.326-7.772,13.5,15.04A4.589,4.589,0,0,1,57.934,83.594Z",
    transform: "translate(-19.129 -35.626)",
    fill: "#2f3ead"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(84.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M209.7,38.838a23.59,23.59,0,0,0-12-3.065,24.047,24.047,0,0,0-12.076,3.06,22.075,22.075,0,0,0-8.449,8.58,24.929,24.929,0,0,0-3.053,12.273,24.549,24.549,0,0,0,3.145,12.371,21.968,21.968,0,0,0,8.936,8.585,29.55,29.55,0,0,0,23.588,1.1,21.455,21.455,0,0,0,5.2-3.026,4.8,4.8,0,0,0-5.826-7.631,15.767,15.767,0,0,1-9.622,2.919,15.573,15.573,0,0,1-10.084-3.26,12.3,12.3,0,0,1-4.4-7.056h32.129a3.758,3.758,0,0,0,3.759-3.752,26.028,26.028,0,0,0-2.962-12.51A21.68,21.68,0,0,0,209.7,38.838ZM185.034,55.266a13.187,13.187,0,0,1,21.434-6.857,12.56,12.56,0,0,1,3.893,6.857Z",
    transform: "translate(-174.121 -18.455)",
    fill: "#0e226b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M315.811,37.5l10.63-10.381a4.8,4.8,0,0,0-6.6-6.984L300.132,38.142V5.341a5.341,5.341,0,1,0-10.682,0V59.385a5.341,5.341,0,1,0,10.682,0V51.849l7.736-7.173,14.563,18.1a5.184,5.184,0,0,0,3.575,1.923c.169.016.337.024.5.024a5.225,5.225,0,0,0,4.093-8.459Z",
    transform: "translate(-233.619)",
    fill: "#0e226b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M399.618,0a6.579,6.579,0,0,0-4.827,1.936,6.38,6.38,0,0,0-1.936,4.66,6.241,6.241,0,0,0,1.948,4.631,6.658,6.658,0,0,0,4.815,1.881,6.58,6.58,0,0,0,4.827-1.936,6.48,6.48,0,0,0,1.936-4.744,6.111,6.111,0,0,0-1.963-4.6A6.753,6.753,0,0,0,399.618,0Z",
    transform: "translate(-286.966 0)",
    fill: "#8222ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M401.135,36.637a5.347,5.347,0,0,0-5.341,5.341V78.286a5.341,5.341,0,1,0,10.682,0V41.978A5.347,5.347,0,0,0,401.135,36.637Z",
    transform: "translate(-288.482 -18.901)",
    fill: "#0e226b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M472.186,61.292a14.315,14.315,0,0,0-6.216-3.915,69.421,69.421,0,0,0-8.814-2.005c-2.638-.494-4.7-.937-6.139-1.317a8.244,8.244,0,0,1-3.212-1.577,2.905,2.905,0,0,1-1.029-2.412,3.733,3.733,0,0,1,2.054-3.31c1.563-.977,3.944-1.472,7.078-1.472a23.046,23.046,0,0,1,9.4,1.854,4.892,4.892,0,1,0,3.716-9.048,32.109,32.109,0,0,0-3.853-1.191,38.645,38.645,0,0,0-9.183-1.126c-5.892,0-10.686,1.309-14.247,3.892A12.676,12.676,0,0,0,436.177,50.4c0,3.458.937,6.212,2.783,8.184a14.834,14.834,0,0,0,6.377,4.038,60.763,60.763,0,0,0,8.925,1.969c2.581.44,4.586.841,5.96,1.19a7.766,7.766,0,0,1,3.041,1.454,2.587,2.587,0,0,1,.94,2.157c0,1.162,0,4.7-9.216,4.7a28.081,28.081,0,0,1-8.069-1.2,26.515,26.515,0,0,1-3.88-1.486,4.964,4.964,0,0,0-4.339,8.929,31.362,31.362,0,0,0,4.873,1.833A38.674,38.674,0,0,0,454.4,83.684c6.16,0,11.128-1.276,14.766-3.79a12.386,12.386,0,0,0,5.717-10.67A11.219,11.219,0,0,0,472.186,61.292Z",
    transform: "translate(-309.177 -18.455)",
    fill: "#0e226b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEkisLogoText);
export default __webpack_public_path__ + "static/media/ekis-logo-text.975e831b7f2f8b71410c72145c6422b3.svg";
export { ForwardRef as ReactComponent };